import { render, staticRenderFns } from "./MatchAddressToCustomer.vue?vue&type=template&id=7bfce19c&"
import script from "./MatchAddressToCustomer.vue?vue&type=script&lang=js&"
export * from "./MatchAddressToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports